import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RetryStockReservationForm";
import {cancelRetryStockReservation} from "../../actions/SubscriptionApiActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class RetryStockReservationFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.retrySubscriptionStockReservation({deliveryId: this.props.deliveryId, method: values.get("method")})
      .then((response) => {
        if (response.data.retrySubscriptionStockReservation.errors.length <= 0) {
          this.props.cancelRetryStockReservation();
        } else {
          let errors = createValidationErrors(response.data.retrySubscriptionStockReservation.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRetryStockReservation();
  }

  render() {
    let initialValues = fromJS({
      method: "normal"
    })
    return (
      <Form
        errors={this.state.errors}
        initialValues={initialValues}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const START_DELIVERY = gql`
  mutation retrySubscriptionStockReservation($data: SubscriptionRetryStockReservationInput!) {
    retrySubscriptionStockReservation(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(START_DELIVERY, {
    props: ({ mutate }) => ({
      retrySubscriptionStockReservation: (data) => mutate({
        variables: {
          data: data
        }
      })
    })
  })
);

export default connect(null, {cancelRetryStockReservation})(withMutation(RetryStockReservationFormContainer));